import { render } from "./WorldEnded.vue?vue&type=template&id=4f478051"
import script from "./WorldEnded.vue?vue&type=script&lang=js"
export * from "./WorldEnded.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/WorldEnded.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f478051"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f478051', __exports__)) {
    api.reload('4f478051', __exports__)
  }
  
  module.hot.accept("./WorldEnded.vue?vue&type=template&id=4f478051", () => {
    api.rerender('4f478051', render)
  })

}


export default __exports__